const initialState = {
    loading: false,
    loaded: false,
    tags: []
};

export default function tags(state = initialState, action = {}) {
    switch (action.type) {
        case 'LOAD_TAGS':
            return {
                ...state,
                loading: true
            };
        case 'LOAD_TAGS_SUCCESS':
            return {
                ...state,
                tags: action.result
            };
        case 'CREATE_TAG_SUCCESS':
            return {
                ...state,
                tags: state.tags.concat(action.result)
            };
        default:
            return state;
    }
}

export function loadTags() {
    return {
        types: ['LOAD_TAGS', 'LOAD_TAGS_SUCCESS', 'LOAD_TAGS_FAIL'],
        promise: (api) => api.get('tags')
    };
}

export function createTag({name}) {
    return {
        types: ['CREATE_TAG', 'CREATE_TAG_SUCCESS', 'CREATE_TAG_FAIL'],
        promise: (api) => api.post('tags', {name})
    };
}


// WEBPACK FOOTER //
// ./app/reducers/tags.js